import { makeStateKey, TransferState } from "@angular/platform-browser";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { filter } from "rxjs/operators";

import { VenueService } from "./venue.service";
import { PitchData } from "../shared/model/pitch";
import { VenueData } from "../shared/model/venue";
import { isPlatformBrowser } from "@angular/common";
import { LinkService } from "../shared/link.service";
import { ApiEndpoints } from "../shared/apiEndpoints";
import { VenueCollection } from "../shared/model/venueCollection";
import { ConfigureService } from "../configure/configure.service";

const PITCHDATA = makeStateKey("pitchData");
const VENUEDATA = makeStateKey("venueData");

@Injectable()
export class VenueResolver implements Resolve<any> {
    private isBrowser: boolean = isPlatformBrowser(this.platformId);

    constructor(
        private router: Router,
        private venueService: VenueService,
        private apiEndpoints: ApiEndpoints,
        private linkService: LinkService,
        private transferState: TransferState,
        @Inject(PLATFORM_ID) private platformId,
        private configureService: ConfigureService
    ) {}

    resolve(
        activatedRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): any {
        const slug = activatedRoute.params["slug"];
        const city = activatedRoute.params["city"];
        this.configureService.paramsLoadedSubject
            .pipe(filter((data) => !!data))
            .subscribe(() => {
                // find venue by slug
                this.apiEndpoints.findVenueBySlug(slug, city).subscribe(
                    (venueData: VenueCollection) => {

                        if (venueData.data.length > 0 && venueData.included) {
                            const pitchId = venueData.included[0].id;

                            this.apiEndpoints
                                .callMlpApiPitch(pitchId)
                                .subscribe((pitchData: PitchData) => {
                                    const venueId = pitchData.included[0].id;

                                    this.apiEndpoints
                                        .callMlpApiVenue(venueId)
                                        .subscribe((venueData: VenueData) => {
                                            this.venueService.pitchData =
                                                pitchData;
                                            this.venueService.pitchDataChange.emit(
                                                pitchData
                                            );

                                            this.venueService.venueData =
                                                venueData;
                                            this.venueService.venueDataChange.emit(
                                                venueData
                                            );

                                            // render canonical url
                                            if (!this.isBrowser) {
                                                this.transferState.set(
                                                    PITCHDATA,
                                                    pitchData
                                                );
                                                this.transferState.set(
                                                    VENUEDATA,
                                                    venueData
                                                );
                                            }
                                        });
                                });
                        } else {
                            this.venueService.venueDataChange.emit(null);
                        }
                    },
                    () => {
                        this.venueService.venueDataChange.emit(null);
                    }
                );
            });
    }
}
